import React from 'react';
import YesOrNo from './YesOrNo.jsx';

export default function Step4(props) {
  const { widths, getStandard, getHasWidth, setHasWidth, getWidth, setWidth } = props;
  const strings = window.themeStrings || {};

  return (
    <div className="form-body">
      <YesOrNo setValue={setHasWidth} getValue={getHasWidth} label={strings.fit_finder_step4_buy_narrow_wide}  />
      {getHasWidth &&
        <fieldset className="form-field">
          <legend className="form-legend">{strings.fit_finder_step4_what_width}</legend>
          <div className="option-values option-values-one-line">
            {widths[getStandard.code]
              .map((width, index) => {
                return (
                  <div key={index} className="option-value">
                    <input
                      type="radio"
                      className="option-value-input"
                      id={`width-${index}`}
                      name="width"
                      value={width}
                      checked={getWidth === width}
                      onChange={() => setWidth(width)} />
                    <label htmlFor={`width-${index}`} className="option-value-name">{width}</label>
                  </div>
                )
              })
            }
          </div>
        </fieldset>}
    </div>
  )
}